import { FC } from 'react';
import KpiCard from '../../../../shared/KpiCard/KpiCard';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamRtpStatusMetric } from '../../../../models/injury';
import styles from './TeamRtpStatusCard.module.scss';

interface Props {
  data: ITeamRtpStatusMetric | null;
}

export const TeamRtpStatusCard: FC<Props> = ({ data }) => {
  if (!data?.data?.length) return <ChartEmptyState />;

  const inRtp = data.data.find((d) => d.phase === 'in-rtp')?.count ?? 0;
  const noRtp = data.data.find((d) => d.phase === 'no-rtp')?.count ?? 0;
  const total = inRtp + noRtp;

  if (total === 0) return <ChartEmptyState />;

  return (
    <div className={styles.wrapper}>
      <div className={styles.grid}>
        <KpiCard label="In RTP" value={String(inRtp)} tone="neutral" />
        {/* Senza protocollo su infortuni attivi = copertura clinica mancante -> danger */}
        <KpiCard label="Senza RTP" value={String(noRtp)} tone={noRtp > 0 ? 'danger' : 'neutral'} />
      </div>
      <p className={styles.footnote}>{total} infortuni attivi totali</p>
    </div>
  );
};
